
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import * as utf8 from 'crypto-js/enc-utf8';
import AES = require('crypto-js/aes');
import { RoleAccess } from '../../../models/role-access.model';
import { UserProfile } from '../../../models/user-profile.model';
import { UserData } from '../../../providers/user-data';
import { AlertController, NavController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UtilService } from '../../../service/util.service';
import { SpgService } from '../spg.service';
import { IonicSelectableComponent } from 'ionic-selectable';
@Component({
  selector: 'app-spg-form',
  templateUrl: './spg-form.page.html',
  styleUrls: ['./spg-form.page.scss'],
})
export class SpgFormPage implements OnInit {
  
  @ViewChild('counterComponent', { static: false }) counterComponent: IonicSelectableComponent
  action:any;
  token: any;
  userProfile: UserProfile = new UserProfile();
  roleAccess = new RoleAccess();
  formSpg: FormGroup;
  spgId:any;
  selectedCounter:any[]=[];
  mstCounterList:any=[];
  constructor(
    private activeRoute: ActivatedRoute,
    private userData: UserData,
    private toastCtrl : ToastController,
    private navCtrl : NavController,
    private alertController : AlertController,
    private storage: Storage,
    private router: Router,
    private fb: FormBuilder,
    private utilService:UtilService,
    private spgService:SpgService
  ) { }

  ngOnInit() {
    this.buildFormSpg();
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.roleAccess = this.userData.checkAccess(this.router.url, access, this.userProfile);
        if(!this.roleAccess || this.roleAccess.update!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        }
        this.getData();
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }

  buildFormSpg() {
    this.formSpg = this.fb.group({
      counterList:[null],
      spgName: [null],
      activeFlag: ['Y']
    });
  }
  getData() {
    this.activeRoute.queryParams.subscribe((snapshot) => {
      let myKey=environment.myKey;
      this.action = AES.decrypt(snapshot.a, myKey).toString(utf8);
      this.spgId = AES.decrypt(snapshot.i, myKey).toString(utf8);
      this.selectedCounter =[];
      if(this.action!='adds'){
        let option={
          "token": this.token,
          "id":this.spgId,
          "username":this.userProfile.username
        };
        this.spgService.getSpgById(this.spgId,option)
        .subscribe((response: any) => {
          let rs = response.results.spg;
          let spg_name = rs!=null ? rs.spg_name : '';
          let active_flag = rs!=null ? rs.active_flag : 'Y';
          let counter_list = rs!=null ?rs.counter_list:'';
          this.mstCounterList = response.results.counter;
          let counterIdSplit = counter_list !== '' ? String(counter_list).split(',') : [];
          let selectedCounterx = [];
          if(counterIdSplit.length>0){
            for(let i= 0; i < counterIdSplit.length; i++) {        
              let selectedCounter: any = this.mstCounterList.find(x => x.id ==  parseInt(counterIdSplit[i]));
              if(selectedCounter){
                this.selectedCounter.push(selectedCounter.id);  
                selectedCounterx.push(selectedCounter)      
              }
            }
          }
          this.formSpg.patchValue({
            counterList:selectedCounterx,
            spgName: spg_name,
            activeFlag:active_flag
          });
        });
      }
    });
  }
  selectCounter(event){
    this.selectedCounter = [];
    for(let i= 0; i < event.value.length; i++) {
      this.selectedCounter.push(event.value[i]['id']);
    }
  }
  saveSpg(){
    const spgData = this.formSpg.getRawValue();
    if(spgData.spgName==0 || spgData.spgName==null){
      alert("SPG Name tidak boleh kosong");
      return;
    }
    if(this.selectedCounter.length==0){
      alert("Counter tidak boleh kosong");
      return;
    }
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let options = {
        "token": this.token,
        "action":this.action,
        "id":this.spgId,
        "spg_name":spgData.spgName ?  spgData.spgName : '',
        "counter_list":this.selectedCounter.toString(),
        "active_flag":spgData.activeFlag ?  spgData.activeFlag : 'N',
        "username":this.userProfile.username
      };
      this.spgService.saveSpg(options)
      .subscribe((response: any) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 201) {
          this.showConfirmInput();
        }
        else if(response.status.code === 409) {
          this.toastCtrl.create({ duration: 2000, message: response.message }).then(t => t.present());
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error' }).then(t => t.present());
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      })
    });
  }
  async showConfirmInput() {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: 'Data sudah tersimpan!',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.buildFormSpg();
            this.navCtrl.navigateForward(['/spg']);;
          }
        }
      ]
    });
    await alert.present();
  }
  
  toggleCounterItems() {
    this.counterComponent.toggleItems(
      this.counterComponent.itemsToConfirm.length ? false : true
    );
  }

  confirmCounter() {
    this.counterComponent.confirm();
    this.counterComponent.close();
    let counterList = this.counterComponent.value;
    let idCounter ='';
    for(let i=0;i<counterList.length;i++){
      idCounter += this.selectedCounter[i].id+',';
    }
    idCounter = idCounter.replace(/(^,)|(,$)/g, "");
  }
}